import React from "react";
import { Container } from "@mui/system";

import { IoIosMail, IoMdCall } from "react-icons/io";
import { GrClose } from "react-icons/gr";

import { StyledItemContact } from "../../Header/Header.styled";
import { LanguageBar } from "../../LanguageBar/LanguageBar";
import { NavBar } from "../NavBar";
import { Flex } from "../../ui-component/Flex/Flex";

import {
	StiledDropMenu,
	LanguageBarPosition,
	ButtonClosePosition,
} from "./MobileMenu.styled";

export const MobileMenu = ({ toggle }) => {
	return (
		<StiledDropMenu>
			<Container>
				<ButtonClosePosition>
					<GrClose onClick={toggle} />
				</ButtonClosePosition>
				<Flex mobileDirection="column" mobileAlign="center">
					<LanguageBarPosition>
						<LanguageBar />
					</LanguageBarPosition>
					<NavBar toggle={toggle} />
					<ul>
						<Flex mobileDirection="column" mobileAlign="center">
							<StyledItemContact margin="0 0 10px 0">
								<Flex align="center">
									<span>
										<IoIosMail size="24px" />
									</span>
									<a href="mailto:presbetons@gmail.com">
										presbetons@gmail.com
									</a>
								</Flex>
							</StyledItemContact>

							<StyledItemContact margin="0 10px 0 0">
								<Flex align="center">
									<span>
										<IoMdCall size="24px" />
									</span>
									<a href="tel:+380673228999">
										(067) 322-89-99
									</a>
								</Flex>
							</StyledItemContact>
							<StyledItemContact>
								<Flex align="center">
									<span>
										<IoMdCall size="24px" />
									</span>
									<a href="tel:+380673228999">
										(067) 404-62-69
									</a>
								</Flex>
							</StyledItemContact>
						</Flex>
					</ul>
				</Flex>
			</Container>
		</StiledDropMenu>
	);
};
